export default {
  title: 'Brands',
  description: 'Administrate benefit brands',
  new: 'New brand',
  edit: 'Change brand',
  fields: {
    name: 'Name',
    description_placeholder: 'Brand description text. Minimum 50 characters. Maximum 1000 characters',
    website: 'Website',
    scope_availability: 'Availability',
    value: 'Value',
    value_discount: 'Discount/Price',
    discount_items: {
      price: 'Price',
      discount: 'Total Discount',
      user_discount: 'User Discount',
      platform_discount: 'Platform Discount'
    },
    provider: 'Provider',
    is_active_app: 'Is active in UpMobil+',
    actions: 'Actions'
  },
  rules: {
    title: 'Quick Guide – Configuring Benefits in UpMobil+',
    1: 'Default behavior: if no benefit is modified in this panel, all benefits will be displayed in UpMobil+;',
    2: 'Custom behavior: if at least one benefit is modified, the display in UpMobil+ will follow the settings from this panel;',
    3: 'In the “Active in UpMobil+” column: Active → the benefit is displayed in the app / Inactive → the benefit is not displayed;',
    4: 'Availability selected without a period → the benefit is displayed for an indefinite period;',
    5: 'Availability selected with a period (Start date / End date) → the benefit is displayed only within the selected interval; after expiration, it will no longer be displayed;',
    6: '“Save” / “Cancel” appear only when there are unsaved changes;',
    7: '“Cancel” restores the benefit to the default settings.'
  },
  errors: {
    end_date: 'End date is required'
  },
  modal: {
    confirm_save: 'Are you sure you want to save the changes?',
    confirm_leave: 'The information has been changed, are you sure you want to leave?',
    confirm_delete: 'Are you sure you want to delete the brand?',
    extra_delete: 'Current brand assigned to {count_benefits} benefits.'
  },
  tooltips: {
    description: '(min 50, max 1000)'
  },
  scope_availability: {
    benefit: 'Benefits',
    offer: 'Offers',
  },
  nav_tree: {
    benefits_title: 'Benefits mapping',
    offers_title: 'Offers mapping',
    section_hint: 'Choose one or more categories where the brand will be displayed.',
    add_mapping: 'Add mapping',
    badge_existing: 'Existing',
    badge_new: 'New',
    category: 'Category',
    subcategory: 'Subcategory',
    direct_category: 'Map directly to category',
    no_categories: 'There are no categories available in NavTree for this section.',
    empty_title: 'No mappings added yet.',
    empty_subtitle: 'Press Add mapping to select a category.',
    save_mapping: 'Save',
    saving: 'Saving...',
    deleting: 'Deleting...',
    cancel: 'Cancel',
    save_error: 'Could not save the mapping. Please try again.',
    delete_error: 'Could not delete the mapping. Please try again.',
    mappings_saved_individually_info: 'Mappings are saved individually. Press Save on each new mapping to activate it.',
    save_info: 'For mapping changes to take effect, press the Save button.',
    errors: {
      required: 'Required field',
      duplicate: 'This category and subcategory combination already exists',
      invalid: 'Invalid value',
      not_allowed: 'Mapping is not allowed for this brand',
      tree_not_found: 'NavTree was not found',
    },
  },
}
